import { z } from "zod";
import { MediumLengthString, ShortString } from "../validate";

const defaultGroupId = "default";
export const defaultGroup: Group = {
    id: defaultGroupId,
    displayName: "Default",
    description: "Group for members without a group",
};

export const GroupId = z
    .string()
    .regex(/^[a-z0-9][-a-z0-9]{0,254}$/, "Invalid group id.");
export const Group = z.object({
    id: GroupId,
    displayName: ShortString,
    description: MediumLengthString.optional(),
});

export type Group = z.infer<typeof Group>;
export type GroupId = z.infer<typeof GroupId>;
